import { render, staticRenderFns } from "./FarabiResult.vue?vue&type=template&id=266c2b1f&scoped=true&"
import script from "./FarabiResult.vue?vue&type=script&lang=js&"
export * from "./FarabiResult.vue?vue&type=script&lang=js&"
import style0 from "./FarabiResult.vue?vue&type=style&index=0&id=266c2b1f&lang=scss&scoped=true&"
import style1 from "./FarabiResult.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266c2b1f",
  null
  
)

export default component.exports